import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnterpriseLicense, LoggedInUserLicenseDetails, UpdateLicenseRequest } from 'src/app/predictor-enterprise-license/shared/interface/Enterprise-License';
import { LicenseDetails, UpdateUserRequest } from 'src/app/predictor-enterprise-license/shared/interface/License-details';
import { LicenseTierDropdown } from 'src/app/predictor-enterprise-license/shared/interface/license-tiers';
import { LicenseUser } from 'src/app/predictor-enterprise-license/shared/interface/license-user';


@Injectable({
  providedIn: 'root'
})
export class EnterpriseLicenseService {

  private readonly baseUrl = '/api/License'; // Change to your actual backend endpoint
  private readonly auditBaseUrl = '/api/AuditDetails'; // Change to your actual backend endpoint

  constructor(private readonly http: HttpClient) { }

  getAll(): Observable<EnterpriseLicense[]> {
    return this.http.get<EnterpriseLicense[]>(this.baseUrl);
  }

  getById(id: string): Observable<EnterpriseLicense> {
    return this.http.get<EnterpriseLicense>(`${this.baseUrl}/${id}`);
  }

  create(license: EnterpriseLicense): Observable<EnterpriseLicense> {
    return this.http.post<EnterpriseLicense>(this.baseUrl, license);
  }

  update(id: string, license: UpdateLicenseRequest): Observable<EnterpriseLicense> {
    return this.http.patch<EnterpriseLicense>(`${this.baseUrl}`, license);
  }

   licenseToggle(licenseNumber : string): Observable<EnterpriseLicense> {
    return this.http.patch<EnterpriseLicense>(`${this.baseUrl}/Activate?licenseNumber=${licenseNumber}`,null);
  }
deleteLicense(licenseNumber:string):Observable<boolean>{
  return this.http.delete<boolean>(`${this.baseUrl}?licenseNumber=${licenseNumber}`);
}
  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
  getAuditRecords(licenseNumber:string){
    return this.http.get<any>(`${this.auditBaseUrl}/AuditRecords?licenseNumber=${licenseNumber}`);
  }

  getUsersByLicenseNumber(licenseNumber: string): Observable<LicenseUser[]> {
    return this.http.get<LicenseUser[]>(`${this.baseUrl}/Users/${licenseNumber}`);
  }
  getLicenseTiers(): Observable<LicenseTierDropdown[]> {
    return this.http.get<LicenseTierDropdown[]>(`${this.baseUrl}/LicenseTiers`);
  }

  getLicenseDetails(licenseNumber: string): Observable<LicenseDetails> {
    return this.http.get<LicenseDetails>(`${this.baseUrl}/LicenseDetails?licenseNumber=${licenseNumber}`);
  }

  getLoggedInUserLicense(): Observable<LoggedInUserLicenseDetails> {
    return this.http.get<LoggedInUserLicenseDetails>(`${this.baseUrl}/UserLicense`);
  }

   updateLicenseUser(userRequest: UpdateUserRequest): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/UpdateUser`, userRequest);
  }

  private Licensedata: any;
  private licenseTiersData: LicenseTierDropdown[] = [];

  setLicenseData(data: any, licenseTiers: LicenseTierDropdown[]) {
    this.Licensedata = data;
    this.licenseTiersData = licenseTiers;
  }

  getLicenseData() {
    return {Licensedata:this.Licensedata, licenseTiers: this.licenseTiersData};
  }

  clearLicenseData() {
    this.Licensedata = null;
  }
}

